import { IFrame, IFramePermission } from "client/Components";
import { ReactElement } from "react";
import styles from "./Roadmap.module.less";
import { usePageTitle } from "client/Hooks/usePageTitle";
import { localize } from "client_legacy/ndaw/culture";

export const RoadmapPage = (): ReactElement => {
	usePageTitle(localize("_Roadmap"));

	return (
		<IFrame
			src="https://roadmap.workspace365.net"
			permissions={iframePermissions}
			trackingId="roadmap"
			className={styles.root}
		/>
	);
};
RoadmapPage.displayName = "RoadmapPage";

export const roadmapRouting = {
	page: "/Roadmap"
};

const iframePermissions: readonly IFramePermission[] = [
	IFramePermission.Downloads,
	IFramePermission.Forms,
	IFramePermission.Modals,
	IFramePermission.OrientationLock,
	IFramePermission.PointerLock,
	IFramePermission.Popups,
	IFramePermission.EscapingPopups,
	IFramePermission.Presentation,
	IFramePermission.SameOrigin,
	IFramePermission.Scripts
];
